<template>
	<div class="searchBar">
		<autocomplete ref="searchBar" :submitOnEtner="true" :get-result-value="getResultValue" :search="search" @submit="handleSubmit"
			:debounce-time="100"></autocomplete>
	</div>
</template>
 
<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import Fuse from 'fuse.js'

export default {
	name: 'SearchBar',
	components: {
		Autocomplete
	},
	async mounted() {
		try {
			let response = await axios.get(window.basedir + '/ajaxRequestServlet?mode=AttributeValues&isSearchable=true&isOnProducts=true')
			response.data.attributes.forEach(attr => {
				if (attr.attribute.toLowerCase() == "keywords") {
					this.attributes = attr.values
				}
			})
			this.fuzzy = new Fuse(this.attributes, { keys: ["name"], distance: 20, minMatchCharLength: 3, threshold: 0.3, includeScore: true });
		} catch (err) {
			console.log(err)
		}
		this.$store.subscribe((mutation, state) => {
			switch (mutation.type) {
				case 'setFilter':
					if (state.filter.length > 0) {
						this.search('');
						this.$refs.searchBar.value = '';
					}
					break;
			}
		})
	},
	data() {
		return {
			attributes: [],
			fuzzy: null,
			timeout: null,
			cachedSearch: ''
		}
	},
	methods: {
		search(input) {

			if (input.length < 1) {
				this.$store.state.searchResult.show = false;
				this.$store.dispatch("loadButtons", true)
				setTimeout(() => {
					this.$emit('setHeight')
				}, 400)
				return []
			}
			if (input.length > 2 && this.cachedSearch != input) {
				this.cachedSearch = input
				if (this.timeout) {
					clearTimeout(this.timeout)
				}
				this.timeout = setTimeout(async () => {
					if (this.$store.state.searchResult?.result.length <= 1 && this.fuzzy.search(input).map(x => x.item).length && this.fuzzy.search(input)[0].score < 0.3) {
						this.$store.dispatch('collectItemsFromSearchQuery', this.fuzzy.search(input).map(x => x.item)[0]?.name)
					} else {
						this.$store.dispatch('collectItemsFromSearchQuery', this.$refs.searchBar.value)
					}
					clearTimeout(this.timeout)
				}, 600)
			}
			return this.fuzzy.search(input).map(x => x.item)

		},
		handleSubmit(result) {
			this.$store.dispatch('collectItemsFromSearchQuery', this.$refs.searchBar.value)
		},
		getResultValue(result) {
			return result.name
		}
	}
}
</script>
 
<style lang="scss">
.searchBar {
	width: calc(91% - 50px);
	float: left;

	.autocomplete-input {
		height: 43px;
		font-weight: bold;
		color: #004570;
		background-color: white;
		border: 1px solid #004570;
		border-radius: 4px;
	}

	.autocomplete-result-list {
		margin-top: 0px;
		border: 1px solid #004570;
		border-top: none;
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;

		li {
			text-align: left;
			font-weight: bold;
			opacity: 0.8;
			color: #004570;
		}
	}

	.autocomplete-result:hover,
	.autocomplete-result[aria-selected=true] {
		color: #004570;
		opacity: 1;
	}
}

@media screen and (max-width: 900px) {
	.searchBar {
		width: 60%;
	}
}

@media screen and (max-width: 700px) {
	.searchBar {
		width: 100%;
	}
}

@media screen and (max-width: 500px) {
	.searchBar {
		width: 100%;
		margin-bottom: 20px;
	}
}
</style>